(function () {
  var SHAPE_LABELS = {
    oval: "Oval",
    round: "Round",
    square: "Square",
    heart: "Heart",
    oblong: "Oblong",
  };
  var STYLE_LABELS = {
    classic: "Classic & Subtle",
    bold: "Bold & Statement",
    sporty: "Sporty & Active",
  };
  var USE_LABELS = {
    everyday: "Everyday",
    work: "Work & Professional",
    outdoor: "Outdoor & Sun",
    screen: "Screen Time",
  };
  var STEP_PROGRESS = {
    intro: 1,
    consent: 1,
    camera: 1,
    manual: 1,
    preferences: 2,
    loading: 3,
    results: 3,
  };
  var CONSENT_KEY = "fyf_consent_given";
  var FACE_DETECTION_URLS = [
    "https://cdn.jsdelivr.net/npm/@mediapipe/face_detection@0.4/face_detection.js",
    "https://cdn.shopify.com/s/files/1/0730/0864/4391/files/face_detection.js?v=1754244006",
  ];

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".find-your-fit").forEach(function (section) {
      initializeSection(section);
    });
  });

  function initializeSection(section) {
    var state = {
      flow: "camera",
      faceShape: "oval",
      faceSize: "medium",
      sizeKnown: "no",
      frameSizeMm: "",
      colorPreference: "none",
      gender: "women",
      styleVibe: "classic",
      primaryUse: "everyday",
      stream: null,
      capturedBlob: null,
      capturedPreviewUrl: "",
      detectionInstance: null,
      detectionTimer: null,
      detectionInFlight: false,
      captureTimeoutId: null,
      stableSince: 0,
      lastBox: null,
      captureRequested: false,
      latestResponse: null,
      consentGiven: getStoredConsent(),
    };

    var els = {
      status: section.querySelector('[data-role="status"]'),
      video: section.querySelector('[data-role="video"]'),
      canvas: section.querySelector('[data-role="canvas"]'),
      cameraShell: section.querySelector('[data-role="camera-shell"]'),
      cameraStatus: section.querySelector('[data-role="camera-status"]'),
      cameraHint: section.querySelector('[data-role="camera-hint"]'),
      manualCapture: section.querySelector('[data-role="manual-capture"]'),
      fileInput: section.querySelector('[data-role="file-input"]'),
      fileName: section.querySelector('[data-role="file-name"]'),
      shapeGrid: section.querySelector('[data-role="shape-grid"]'),
      faceSize: section.querySelector('[data-role="face-size"]'),
      sizeKnownGroup: section.querySelector('[data-role="size-known-options"]'),
      sizeVisual: section.querySelector('[data-role="size-visual"]'),
      sizeMmField: section.querySelector('[data-role="frame-size-mm-field"]'),
      sizeMm: section.querySelector('[data-role="frame-size-mm"]'),
      colorGroup: section.querySelector('[data-role="color-options"]'),
      loadingCopy: section.querySelector('[data-role="loading-copy"]'),
      results: section.querySelector('[data-role="results"]'),
      toast: section.querySelector('[data-role="toast"]'),
      manualMessage: section.querySelector('[data-role="manual-message"]'),
    };

    bindOptionGroup(section.querySelector('[data-role="gender-options"]'), function (value) {
      state.gender = value;
    });
    bindOptionGroup(section.querySelector('[data-role="style-options"]'), function (value) {
      state.styleVibe = value;
    });
    bindOptionGroup(section.querySelector('[data-role="use-options"]'), function (value) {
      state.primaryUse = value;
    });
    bindOptionGroup(els.sizeKnownGroup, function (value, button, container) {
      state.sizeKnown = value || "no";
      container.dataset.value = state.sizeKnown;
      toggleSizeFields(els, state);
    });
    bindOptionGroup(els.colorGroup, function (value) {
      state.colorPreference = value || "none";
    });

    if (els.shapeGrid) {
      els.shapeGrid.addEventListener("click", function (event) {
        var target = event.target.closest("[data-shape]");
        if (!target) return;
        state.faceShape = target.dataset.shape || "oval";
        selectButtonGroup(els.shapeGrid.querySelectorAll("[data-shape]"), target);
      });
    }

    if (els.faceSize) {
      els.faceSize.addEventListener("change", function () {
        state.faceSize = normalizeFaceSize(els.faceSize.value || "medium");
        syncSizePills(els, state);
      });
    }

    if (els.sizeMm) {
      els.sizeMm.addEventListener("input", function () {
        state.frameSizeMm = els.sizeMm.value.trim();
      });
    }

    if (els.fileInput) {
      els.fileInput.addEventListener("change", async function () {
        if (!els.fileInput.files || !els.fileInput.files[0]) return;
        /* Do not advance the flow when the photo could not be prepared: the
           shopper stays on the capture step with an explanation. */
        var accepted = await setCapturedFile(state, els.fileInput.files[0], els);
        if (!accepted) return;
        stopCamera(state, els.video);
        state.flow = "camera";
        showStep(section, "preferences");
        setStatus(els.status, "Photo ready. Add your style preferences.");
      });
    }

    section.addEventListener("click", async function (event) {
      // Colour swatches on result cards: select in place (see selectSwatch).
      // Handled inside this one delegated listener; modified clicks fall through
      // to the link's normal navigation.
      var swatchEl = event.target.closest("a[data-fyf-swatch]");
      if (swatchEl) {
        selectSwatch(section, els, swatchEl, event);
        return;
      }
      var trigger = event.target.closest("[data-action]");
      if (!trigger) return;

      switch (trigger.dataset.action) {
        case "start":
          state.flow = "camera";
          if (state.consentGiven) {
            showStep(section, "camera");
            await startCameraFlow(section, state, els);
          } else {
            showStep(section, "consent");
            setStatus(els.status, "Please confirm before we open the camera.");
          }
          break;
        case "give-consent":
          state.consentGiven = true;
          storeConsent();
          showStep(section, "camera");
          await startCameraFlow(section, state, els);
          break;
        case "decline-consent":
        case "manual":
        case "switch-manual":
        case "open-manual":
          stopCamera(state, els.video);
          clearCaptured(state);
          state.flow = "manual";
          updateManualMessage(els, "");
          showStep(section, "manual");
          setStatus(els.status, "Answer a few quick fit questions.");
          break;
        case "camera-back":
          stopCamera(state, els.video);
          showStep(section, "intro");
          setStatus(els.status, "");
          break;
        case "retry-camera":
          clearCaptured(state);
          showStep(section, "camera");
          await startCameraFlow(section, state, els);
          break;
        case "trigger-upload":
          if (els.fileInput) els.fileInput.click();
          break;
        case "manual-capture":
          await captureFromVideo(section, state, els);
          break;
        case "continue-preferences":
          state.flow = "manual";
          showStep(section, "preferences");
          setStatus(els.status, "Tell us how you want your frames to feel.");
          break;
        case "back-capture":
          if (state.flow === "manual") {
            showStep(section, "manual");
          } else {
            showStep(section, "camera");
            await startCameraFlow(section, state, els);
          }
          break;
        case "get-results":
          await fetchResults(section, state, els);
          break;
        case "retake":
          // showStep first: resetQuiz empties the results container, which
          // removes the focused Retake button, and showStep needs to see that
          // focus was inside the section to move it to the landing heading.
          showStep(section, "intro");
          resetQuiz(section, state, els);
          break;
        case "share":
          await shareResults(state, els);
          break;
      }
    });

    // A link activates on Enter natively but not on Space, which a swatch should
    // also accept as a selectable choice.
    section.addEventListener("keydown", function (event) {
      if (event.key !== " " && event.code !== "Space") return;
      var swatchEl = event.target.closest && event.target.closest("a[data-fyf-swatch]");
      if (swatchEl) selectSwatch(section, els, swatchEl, event);
    });

    toggleSizeFields(els, state);
    hydrateFromQuery(section, state, els, new URLSearchParams(window.location.search));
  }

  async function startCameraFlow(section, state, els) {
    stopCamera(state, els.video);
    clearCaptured(state);
    state.captureRequested = false;
    state.stableSince = 0;
    state.lastBox = null;
    hideManualCapture(els);
    setCameraMessage(els, "Align your face with the guide.", "Move closer until your face fills the oval.");

    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      setCameraMessage(els, "Camera not available on this device.", "Upload a selfie instead.");
      return;
    }

    try {
      var videoConstraints = isMobileViewport()
        ? { facingMode: "user", width: { ideal: 720 }, height: { ideal: 960 } }
        : { facingMode: "user", width: { ideal: 960 }, height: { ideal: 720 } };
      state.stream = await navigator.mediaDevices.getUserMedia({
        video: videoConstraints,
        audio: false,
      });
      els.video.srcObject = state.stream;
      await els.video.play();
      drawGuide(els.canvas, els.video, null);
      setStatus(els.status, "Camera active. Hold still for auto-capture.");
    } catch (err) {
      setCameraMessage(els, "Camera access denied.", "Upload a selfie or use the manual quiz.");
      setStatus(els.status, "Camera permission denied.");
      return;
    }

    var faceDetectionApi = await loadFaceDetection();
    if (!faceDetectionApi) {
      setCameraMessage(els, "Live positioning is unavailable.", "You can still take a photo manually or upload one.");
      revealManualCapture(els);
      return;
    }

    var FaceDetectionCtor = typeof faceDetectionApi === "function" ? faceDetectionApi : faceDetectionApi.FaceDetection;
    if (typeof FaceDetectionCtor !== "function") {
      revealManualCapture(els);
      return;
    }

    if (!state.detectionInstance) {
      state.detectionInstance = new FaceDetectionCtor({
        locateFile: function (file) {
          return "https://cdn.jsdelivr.net/npm/@mediapipe/face_detection@0.4/" + file;
        },
      });
      state.detectionInstance.setOptions({ model: "short", minDetectionConfidence: 0.5 });
      state.detectionInstance.onResults(function (results) {
        handleDetectionResults(section, state, els, results);
      });
    }

    state.captureTimeoutId = window.setTimeout(function () {
      revealManualCapture(els);
    }, isMobileViewport() ? 3000 : 5000);
    state.detectionTimer = window.setInterval(async function () {
      if (!state.stream || state.captureRequested || state.detectionInFlight) return;
      if (!els.video || els.video.readyState < 2) return;
      try {
        state.detectionInFlight = true;
        await state.detectionInstance.send({ image: els.video });
      } catch (err) {
        revealManualCapture(els);
      } finally {
        state.detectionInFlight = false;
      }
    }, 180);
  }

  function handleDetectionResults(section, state, els, results) {
    var detection = results && results.detections && results.detections[0];
    var box = readBoundingBox(detection);
    drawGuide(els.canvas, els.video, box);

    if (!box) {
      state.stableSince = 0;
      state.lastBox = null;
      setCameraMessage(els, "Center your face", "Good light helps the camera lock on.");
      return;
    }

    var evaluation = evaluateBox(box, state.lastBox);
    state.lastBox = box;
    setCameraMessage(els, evaluation.prompt, evaluation.subPrompt);
    if (!evaluation.ready) {
      state.stableSince = 0;
      return;
    }

    if (!state.stableSince) state.stableSince = Date.now();
    if (Date.now() - state.stableSince >= 500) captureFromVideo(section, state, els);
  }

  async function captureFromVideo(section, state, els) {
    if (state.captureRequested || !els.video || els.video.readyState < 2) return;
    state.captureRequested = true;

    try {
      var resized = await resizeVideoFrame(els.video);
      if (!resized.ok) {
        state.captureRequested = false;
        /* Same reason as the picker path: stop the loop or the message is lost. */
        stopCamera(state, els.video);
        revealManualCapture(els);
        setCameraMessage(els, "We couldn't prepare that photo.", resizeFailureCopy(resized.reason));
        setStatus(els.status, "Photo not accepted.");
        return;
      }
      state.flow = "camera";
      state.capturedBlob = resized.blob;
      state.capturedPreviewUrl = URL.createObjectURL(resized.blob);
      stopCamera(state, els.video);
      flashCapture(els);
      showStep(section, "preferences");
      setStatus(els.status, "Photo captured. Add your style preferences.");
    } catch (err) {
      state.captureRequested = false;
      revealManualCapture(els);
      setCameraMessage(els, "We couldn't capture the photo.", "Try again or upload a selfie instead.");
    }
  }

  /* ── Upload byte budget ─────────────────────────────────────────────────
     A BYTE budget, not a pixel target: the dimensions that produce a given
     file size vary enormously with content. Mirrors lib/tyf/resize-image.ts,
     which is the reference implementation — keep the two in step.

     The client budget sits below the server's 2 MiB image budget so the server
     limit is a backstop against hostile callers, not something a shopper meets.
  ─────────────────────────────────────────────────────────────────────────── */
  var UPLOAD_MAX_BYTES = 1.5 * 1024 * 1024;
  var UPLOAD_MAX_EDGE = 1600;
  var UPLOAD_RETRY_EDGE = 800;
  var UPLOAD_QUALITY_LADDER = [0.85, 0.75, 0.65, 0.55];
  var UPLOAD_ACCEPTED_TYPES = ["image/jpeg", "image/png", "image/webp"];
  var REQUEST_TIMEOUT_MS = 15000;

  function fitWithin(width, height, maxEdge) {
    var longest = Math.max(width, height);
    if (longest <= maxEdge) return { width: width, height: height };
    var scale = maxEdge / longest;
    return {
      width: Math.max(1, Math.round(width * scale)),
      height: Math.max(1, Math.round(height * scale)),
    };
  }

  async function encodeLadder(drawable, srcW, srcH) {
    var edges = [UPLOAD_MAX_EDGE, UPLOAD_RETRY_EDGE];
    for (var e = 0; e < edges.length; e++) {
      for (var q = 0; q < UPLOAD_QUALITY_LADDER.length; q++) {
        var quality = UPLOAD_QUALITY_LADDER[q];
        var dims = fitWithin(srcW, srcH, edges[e]);
        var canvas = document.createElement("canvas");
        canvas.width = dims.width;
        canvas.height = dims.height;
        var context = canvas.getContext("2d");
        if (!context) return { ok: false, reason: "undecodable" };
        context.drawImage(drawable, 0, 0, dims.width, dims.height);
        var blob = await new Promise(function (resolve) {
          canvas.toBlob(function (b) { resolve(b); }, "image/jpeg", quality);
        });
        if (!blob) return { ok: false, reason: "undecodable" };
        if (blob.size <= UPLOAD_MAX_BYTES) {
          return { ok: true, blob: blob, width: dims.width, height: dims.height, quality: quality };
        }
      }
      /* Quality floor reached at this edge. Halve the longest edge ONCE and
         restart the ladder at the TOP rather than compressing further: a smaller
         image at good quality analyses better than a larger one at bad quality. */
    }
    return { ok: false, reason: "too_large_after_retry" };
  }

  async function resizeVideoFrame(video) {
    var width = video.videoWidth || 0;
    var height = video.videoHeight || 0;
    if (!width || !height) return { ok: false, reason: "undecodable" };
    return await encodeLadder(video, width, height);
  }

  async function resizeUploadedFile(file) {
    var declared = String(file.type || "").split(";")[0].trim().toLowerCase();
    /* Rejected here rather than mid-upload. HEIC from an iPhone is the realistic
       case and fails opaquely if left to the server. */
    if (UPLOAD_ACCEPTED_TYPES.indexOf(declared) === -1) {
      return { ok: false, reason: "unsupported_type" };
    }
    var bitmap;
    try {
      bitmap = await createImageBitmap(file);
    } catch (err) {
      return { ok: false, reason: "undecodable" };
    }
    if (!bitmap.width || !bitmap.height) return { ok: false, reason: "undecodable" };
    try {
      /* Canvas allocation, drawImage and toBlob can all throw. Uncaught, they
         reject the async change handler (which has no catch), leaving an
         unhandled rejection and NO message for the shopper. */
      return await encodeLadder(bitmap, bitmap.width, bitmap.height);
    } catch (err) {
      return { ok: false, reason: "undecodable" };
    } finally {
      if (bitmap.close) bitmap.close();
    }
  }

  function resizeFailureCopy(reason) {
    if (reason === "unsupported_type") {
      return "Please use a JPEG, PNG, or WebP photo — or answer a few quick questions instead.";
    }
    if (reason === "too_large_after_retry") {
      return "We couldn't shrink that photo enough to upload. Try a smaller one, or answer a few quick questions instead.";
    }
    return "We couldn't read that photo. Try a different one, or answer a few quick questions instead.";
  }

  async function captureVideoFrame(video) {
    var width = video.videoWidth || 960;
    var height = video.videoHeight || 720;
    var canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;

    var context = canvas.getContext("2d");
    if (!context) return null;
    context.drawImage(video, 0, 0, width, height);

    return await new Promise(function (resolve) {
      canvas.toBlob(function (blob) {
        resolve(blob);
      }, "image/jpeg", 0.85);
    });
  }

  function drawGuide(canvas, video, box) {
    if (!canvas || !video) return;
    var width = video.videoWidth || video.clientWidth || 720;
    var height = video.videoHeight || video.clientHeight || 540;
    canvas.width = width;
    canvas.height = height;

    var context = canvas.getContext("2d");
    if (!context) return;
    context.clearRect(0, 0, width, height);
    context.save();
    context.strokeStyle = "rgba(255,255,255,0.88)";
    context.lineWidth = Math.max(4, width * 0.008);
    context.setLineDash([18, 12]);
    var isPortrait = height > width;
    var rx = isPortrait ? width * 0.30 : width * 0.22;
    var ry = isPortrait ? height * 0.22 : height * 0.34;
    context.beginPath();
    context.ellipse(width / 2, height / 2, rx, ry, 0, 0, Math.PI * 2);
    context.stroke();
    context.setLineDash([]);

    if (box) {
      context.strokeStyle = "rgba(26, 26, 46, 0.7)";
      context.lineWidth = 3;
      context.strokeRect(box.x * width, box.y * height, box.width * width, box.height * height);
    }
    context.restore();
  }

  async function loadFaceDetection() {
    if (window.__fyfFaceDetectionApi) return window.__fyfFaceDetectionApi;

    for (var i = 0; i < FACE_DETECTION_URLS.length; i++) {
      try {
        await loadScript(FACE_DETECTION_URLS[i]);
        if (window.FaceDetection) {
          window.__fyfFaceDetectionApi = window;
          return window.__fyfFaceDetectionApi;
        }
      } catch (err) {}
    }
    return null;
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-fyf-src="' + src + '"]');
      if (existing) {
        if (existing.dataset.loaded === "true") return resolve();
        existing.addEventListener("load", resolve, { once: true });
        existing.addEventListener("error", reject, { once: true });
        return;
      }

      var script = document.createElement("script");
      script.src = src;
      script.async = true;
      script.dataset.fyfSrc = src;
      script.addEventListener("load", function () {
        script.dataset.loaded = "true";
        resolve();
      }, { once: true });
      script.addEventListener("error", reject, { once: true });
      document.head.appendChild(script);
    });
  }

  function isMobileViewport() {
    return window.innerWidth < 768;
  }

  function evaluateBox(box, lastBox) {
    var centerX = box.x + box.width / 2;
    var centerY = box.y + box.height / 2;
    var horizontalOffset = Math.abs(centerX - 0.5);
    var verticalOffset = Math.abs(centerY - 0.5);
    var size = Math.max(box.width, box.height);
    var area = box.width * box.height;
    var ratio = box.width / Math.max(box.height, 0.001);
    var stable = false;
    var mobile = isMobileViewport();

    // Mobile selfie cams produce portrait video — face bbox is wider relative
    // to frame height, so relax centering, size, and ratio thresholds
    var maxHOffset = mobile ? 0.18 : 0.12;
    var maxVOffset = mobile ? 0.20 : 0.15;
    var minSize = mobile ? 0.25 : 0.4;
    var minArea = mobile ? 0.06 : 0.14;
    var minRatio = mobile ? 0.45 : 0.58;
    var maxRatio = mobile ? 1.10 : 0.95;

    if (horizontalOffset > maxHOffset || verticalOffset > maxVOffset) {
      return { ready: false, prompt: "Center your face", subPrompt: "Keep your face inside the oval guide." };
    }
    if (size < minSize || area < minArea) {
      return { ready: false, prompt: "Move closer", subPrompt: "Fill more of the guide for a sharper result." };
    }
    if (ratio < minRatio || ratio > maxRatio) {
      return { ready: false, prompt: "Face the camera directly", subPrompt: "Keep your head straight and level." };
    }

    // Stability check — slightly more forgiving on mobile (hand shake)
    var posTolerance = mobile ? 0.025 : 0.015;
    var sizeTolerance = mobile ? 0.035 : 0.02;
    if (lastBox) {
      stable =
        Math.abs(lastBox.x - box.x) < posTolerance &&
        Math.abs(lastBox.y - box.y) < posTolerance &&
        Math.abs(lastBox.width - box.width) < sizeTolerance &&
        Math.abs(lastBox.height - box.height) < sizeTolerance;
    }

    if (!stable) {
      return { ready: false, prompt: "Hold still", subPrompt: "Stay steady for a quick auto-capture." };
    }
    return { ready: true, prompt: "Perfect, hold still", subPrompt: "Capturing in a moment." };
  }

  function readBoundingBox(detection) {
    if (!detection) return null;
    var box = detection.boundingBox || detection.locationData && detection.locationData.relativeBoundingBox;
    if (!box) return null;

    var width = numberOr(box.width, 0);
    var height = numberOr(box.height, 0);
    var x = 0;
    var y = 0;

    if (typeof box.xCenter === "number" && typeof box.yCenter === "number") {
      x = box.xCenter - width / 2;
      y = box.yCenter - height / 2;
    } else {
      x = numberOr(box.xmin, numberOr(box.xMin, 0));
      y = numberOr(box.ymin, numberOr(box.yMin, 0));
    }

    return {
      x: clamp(x, 0, 1),
      y: clamp(y, 0, 1),
      width: clamp(width, 0, 1),
      height: clamp(height, 0, 1),
    };
  }

  function stopCamera(state, video) {
    clearTimeout(state.captureTimeoutId);
    // Null the handle too, not just clear the timer — `detectionTimer` below
    // was already nulled and this one was not, so state never fully returned
    // to its initial shape after a teardown.
    state.captureTimeoutId = null;
    // NOTE: `detectionInFlight` is deliberately NOT reset here. It is a mutex
    // over a MediaPipe `send()` that cannot be cancelled; clearing it early
    // would let an immediate restart begin a second, overlapping send. It
    // clears truthfully in its own `finally` when the work actually settles,
    // so the invariant is EVENTUAL, not synchronous.
    if (state.detectionTimer) {
      window.clearInterval(state.detectionTimer);
      state.detectionTimer = null;
    }
    state.captureRequested = false;
    state.stableSince = 0;
    state.lastBox = null;
    if (state.stream) {
      state.stream.getTracks().forEach(function (track) {
        track.stop();
      });
      state.stream = null;
    }
    if (video) video.srcObject = null;
  }

  async function fetchResults(section, state, els) {
    showStep(section, "loading");
    if (els.loadingCopy) {
      els.loadingCopy.textContent = state.capturedBlob
        ? "Uploading your photo and matching frames to your style."
        : "Matching your selected fit profile to the catalog.";
    }
    setStatus(els.status, "Fetching recommendations...");

    var appBase = (section.dataset.appBase || "").replace(/\/$/, "");
    var endpointPath = section.dataset.endpointPath || "/api/recommend";
    var endpoint = appBase + endpointPath;
    var response;

    /* 15s client budget. The server's own Fly proxy timeout is 4s, so in the
       normal case the server answers first and this only fires on a stall. */
    var controller = new AbortController();
    var timeoutId = window.setTimeout(function () { controller.abort(); }, REQUEST_TIMEOUT_MS);

    try {
      if (state.capturedBlob) {
        var formData = new FormData();
        formData.append("image", state.capturedBlob, "find-your-fit.jpg");
        formData.append("gender", state.gender);
        formData.append("styleVibe", state.styleVibe);
        formData.append("primaryUse", state.primaryUse);
        response = await fetch(endpoint, { method: "POST", body: formData, signal: controller.signal });
      } else {
        response = await fetch(endpoint, {
          method: "POST",
          signal: controller.signal,
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            faceShape: state.faceShape,
            faceSize: normalizeFaceSize(state.faceSize),
            colorPreference: state.colorPreference,
            gender: state.gender,
            styleVibe: state.styleVibe,
            primaryUse: state.primaryUse,
          }),
        });
      }

      var payload = normalizePayload(await response.json());
      state.latestResponse = payload;

      if (!payload.ok) {
        handleErrorPayload(section, state, els, payload);
        return;
      }

      renderResults(section, state, els, payload);
      showStep(section, "results");
      setStatus(els.status, "Recommendations ready.");
    } catch (err) {
      /* An abort is the 15s client budget expiring. No retry is attempted from
         here: a second upload would double the shopper's wait and the data cost
         on exactly the connection that just proved too slow. */
      var timedOut = err && err.name === "AbortError";
      showErrorCard(
        els,
        timedOut ? "That took too long" : "We couldn't load recommendations",
        timedOut
          ? "Your connection seems slow. Please try again, or continue with the manual quiz."
          : "Please try again or continue with the manual quiz.",
        "manual",
        section.dataset.browseUrl || "/collections/all"
      );
      setStatus(els.status, timedOut ? "Request timed out." : "Recommendation service is unavailable.");
      showStep(section, "results");
    } finally {
      /* Cleared on EVERY exit — including the early return above on an error
         payload — so a completed request never leaves a pending abort timer. */
      window.clearTimeout(timeoutId);
    }
  }

  function normalizePayload(payload) {
    if (payload && typeof payload.ok === "boolean") return payload;
    if (payload && (payload.topPick || payload.alternatives || payload.faceShapeInsight)) {
      return { ok: true, mode: "legacy", data: payload };
    }
    return {
      ok: false,
      mode: "legacy",
      error: { type: "validation", suggestion: "Unexpected response format.", fallback: null },
    };
  }

  function handleErrorPayload(section, state, els, payload) {
    var error = payload.error || {};
    var suggestion = error.suggestion || "We couldn't analyze that photo.";
    var browseUrl = error.browseAllUrl || section.dataset.browseUrl || "/collections/all";

    if (error.fallback === "browse") {
      showErrorCard(els, "Browse our full collection", suggestion, "browse", browseUrl);
      setStatus(els.status, "Showing catalog fallback.");
      showStep(section, "results");
      return;
    }

    if (error.fallback === "manual" || error.type === "not_enabled") {
      console.warn("[FYF] Enhanced failed, falling back to manual:", error.reason, suggestion);
      stopCamera(state, els.video);
      clearCaptured(state);
      state.flow = "manual";
      updateManualMessage(els, suggestion);
      showStep(section, "manual");
      setStatus(els.status, suggestion);
      return;
    }

    console.error("[FYF] Unexpected response", payload);
    showErrorCard(els, "Something went wrong", suggestion, "manual", browseUrl);
    showStep(section, "results");
  }

  function renderResults(section, state, els, payload) {
    var data = payload.data || {};
    var topPick = data.topPick;
    var alternatives = Array.isArray(data.alternatives) ? data.alternatives : [];
    var browseUrl = data.browseAllUrl || section.dataset.browseUrl || "/collections/all";

    if (!topPick) {
      showErrorCard(els, "No close matches yet", "Try different preferences or browse the full collection.", "browse", browseUrl);
      return;
    }

    bumpResultsGeneration(section);
    var summary = buildSummary(state, data, browseUrl);
    var hero = buildCard(topPick, true, payload.mode);
    var altCards = alternatives.map(function (item) {
      return buildCard(item, false, payload.mode);
    }).join("");

    els.results.innerHTML = summary + hero + (altCards ? '<div class="find-your-fit__result-list">' + altCards + "</div>" : "");
  }

  function buildSummary(state, data, browseUrl) {
    var shapeLabel = data.fitProfile && data.fitProfile.shape && data.fitProfile.shape.primary
      ? SHAPE_LABELS[data.fitProfile.shape.primary] || data.fitProfile.shape.primary
      : SHAPE_LABELS[state.faceShape];
    var fitLabel = data.fitProfile && data.fitProfile.fitCategory
      ? capitalize(data.fitProfile.fitCategory)
      : capitalize(state.faceSize);
    var colorLine = data.colorRecommendation
      ? '<div class="find-your-fit__color-recommendation">' + esc(data.colorRecommendation) + "</div>"
      : "";

    return (
      '<div class="find-your-fit__summary">' +
      '<p class="find-your-fit__kicker">Your fit profile</p>' +
      '<p class="find-your-fit__text">' + esc(data.faceShapeInsight || ("Best match: " + shapeLabel + " face shape.")) + "</p>" +
      colorLine +
      '<p class="find-your-fit__text find-your-fit__meta">' +
      esc(shapeLabel) + " · " + esc(fitLabel) + " fit · " + esc(STYLE_LABELS[state.styleVibe]) + " · " + esc(USE_LABELS[state.primaryUse]) +
      "</p>" +
      '<div class="find-your-fit__summary-links">' +
      '<button class="find-your-fit__button find-your-fit__button--primary" type="button" data-action="share">Share results</button>' +
      '<button class="find-your-fit__button find-your-fit__button--secondary" type="button" data-action="retake">Retake quiz</button>' +
      '<a class="find-your-fit__link" href="' + esc(browseUrl) + '">Browse all frames →</a>' +
      "</div></div>"
    );
  }

  function buildCard(item, isHero, mode) {
    var cardClass = isHero ? "find-your-fit__result-card find-your-fit__result-card--hero" : "find-your-fit__result-card find-your-fit__result-card--alt";
    var imageUrl = item.variantImage || item.imageUrl || "";
    var image = imageUrl
      ? '<div class="find-your-fit__result-media"><img data-fyf-img src="' + esc(imageUrl) + '" alt="' + esc(item.title || "Frame") + '" loading="lazy"></div>'
      : "";
    // `tryOnUrl` is null when this colour has no try-on overlay. The old
    // `item.tryOnUrl || buildVariantUrl(...)` fallback rebuilt a `?vto=1` URL
    // from that null, which is exactly the bug being fixed — a "Try on" button
    // landing on a page where nothing happens. No fallback: null means no CTA.
    var tryOnUrl = item.tryOnUrl || null;
    // The server now always sends a variant-aware `productUrl`; the old
    // client-side fallback is dead and would only let the two drift apart.
    var productUrl = item.productUrl;

    /* Primary CTA. "Try on" ONLY when this colour actually has an overlay —
       otherwise the shopper gets "View product", which is honest and still
       takes them to the right colour. Deliberately NOT a swap to some other
       colour that does support try-on: the card shows this colour, so every
       link on it must resolve to this colour. */
    var primaryCta = tryOnUrl
      ? '<a class="find-your-fit__button find-your-fit__button--primary" href="' + esc(tryOnUrl) + '">Try on</a>'
      : '<a class="find-your-fit__button find-your-fit__button--primary" href="' + esc(productUrl) + '">View product</a>';
    var primaryCtaCompact = tryOnUrl
      ? '<a class="find-your-fit__button find-your-fit__button--primary find-your-fit__button--compact" href="' + esc(tryOnUrl) + '">Try on</a>'
      : '<a class="find-your-fit__button find-your-fit__button--primary find-your-fit__button--compact" href="' + esc(productUrl) + '">View product</a>';
    primaryCta = primaryCta.replace("<a ", "<a data-fyf-cta ");
    primaryCtaCompact = primaryCtaCompact.replace("<a ", "<a data-fyf-cta ");
    var cartBtn = item.variantId
      ? '<form method="post" action="/cart/add" class="find-your-fit__cart-form"><input type="hidden" name="id" data-fyf-cart-id value="' + esc(extractVariantId(item.variantId)) + '"><button class="find-your-fit__icon-btn" data-fyf-cart-btn type="submit" title="Add frame to cart" aria-label="Add frame to cart"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg></button><span class="find-your-fit__frame-only" aria-hidden="true">Frame only</span></form>'
      : "";

    var priceHtml = item.price
      ? '<div class="find-your-fit__result-price" data-fyf-price>' + priceInner(item.price, item.compareAtPrice) + "</div>"
      : "";

    // In-place colour selection needs a verifiable starting point (handle,
    // initial variant and price). Without them the swatches stay plain links.
    var selectable = Array.isArray(item.allColors) && item.allColors.length > 1 &&
      Boolean(item.handle && item.variantId && item.price);
    var initialVariant = extractVariantId(item.variantId);
    var cardAttrs = selectable
      ? ' data-fyf-card data-handle="' + esc(item.handle) + '" data-initial-variant="' + esc(initialVariant) +
        '" data-price="' + esc(item.price) + '" data-compare="' + esc(item.compareAtPrice || "") +
        '" data-title="' + esc(item.title || "Frame") + '"'
      : "";

    /* Short fit badge — e.g. "Perfect Fit" or "Great Fit" */
    var badgeHtml = item.fitLabel
      ? '<span class="find-your-fit__badge">' + esc(item.fitLabel) + "</span>"
      : "";

    /* Color swatches — small circles with tooltip-style labels */
    var swatches = "";
    // Field presence, not response type: the manual quiz now sends the same
    // colour list. Responses without the field simply render no swatches.
    if (Array.isArray(item.allColors) && item.allColors.length > 0) {
      swatches = '<div class="find-your-fit__swatches">' + item.allColors.map(function (color) {
        var classes = "find-your-fit__swatch";
        if (color.recommended) classes += " is-recommended";
        if (!color.inStock) classes += " is-disabled";
        var swatchId = extractVariantId(color.variantId);
        var isSelected = selectable && swatchId === initialVariant;
        if (isSelected) classes += " is-selected";
        var colorHex = colorNameToHex(color.name);
        var style = colorHex ? ' style="--swatch-color:' + colorHex + '"' : "";
        // Per-colour link. When this colour has no overlay the server sends
        // tryOnUrl:null, and we link the colour's own PDP WITHOUT `vto=1` —
        // keeping its variant id, so the swatch never resolves to a different
        // colour or to a colourless product URL.
        var swatchHref = color.tryOnUrl || buildVariantUrl(item.handle, color.variantId, false);
        var swatchAttrs = selectable
          ? ' data-fyf-swatch data-variant="' + esc(swatchId) + '" data-product-url="' + esc(buildVariantUrl(item.handle, color.variantId, false)) +
            '" data-tryon-url="' + esc(color.tryOnUrl || "") + '"' + (isSelected ? ' aria-current="true"' : "")
          : "";
        var unavailable = color.inStock ? "" : " (unavailable)";
        var disabledAttr = color.inStock ? "" : ' aria-disabled="true"';
        return '<a class="' + classes + '" href="' + esc(swatchHref) + '" title="' + esc((color.name || "Color") + unavailable) + '"' + swatchAttrs + disabledAttr + style + '><span class="find-your-fit__swatch-dot"></span><span class="find-your-fit__swatch-label">' + esc((color.name || "Color") + unavailable) + "</span></a>";
      }).join("") + "</div>";
    }

    /* Color insight line (Phase D) — shown when skin tone scoring is active */
    var colorInsightHtml = item.colorInsight
      ? '<p class="find-your-fit__color-insight">' + esc(item.colorInsight) + "</p>"
      : "";

    if (isHero) {
      /* ── Hero card: prominent horizontal layout ── */
      return (
        '<article class="' + cardClass + '"' + cardAttrs + '>' +
        image +
        '<div class="find-your-fit__result-body">' +
        '<div class="find-your-fit__result-topline">' +
        badgeHtml +
        (item.rank === 1 ? '<span class="find-your-fit__top-pick-label">Top pick for you</span>' : "") +
        "</div>" +
        '<h3 class="find-your-fit__title find-your-fit__result-title">' + esc(item.title || "Recommended frame") + "</h3>" +
        priceHtml +
        '<p class="find-your-fit__text find-your-fit__explanation">' + esc(item.explanation || "") + "</p>" +
        colorInsightHtml +
        swatches +
        '<div class="find-your-fit__result-actions">' +
        primaryCta +
        cartBtn +
        // The secondary link is redundant when the primary CTA has already
        // degraded to "View product" — without this the card shows the same
        // action twice.
        '<a class="find-your-fit__link" data-fyf-link href="' + esc(productUrl) + '"' + (tryOnUrl ? "" : " hidden") + '>View product</a>' +
        "</div></div></article>"
      );
    }

    /* ── Alt card: compact vertical layout ── */
    return (
      '<article class="' + cardClass + '"' + cardAttrs + '>' +
      '<a class="find-your-fit__result-media-link" data-fyf-product-link href="' + esc(productUrl) + '">' +
      (imageUrl ? '<img data-fyf-img src="' + esc(imageUrl) + '" alt="' + esc(item.title || "Frame") + '" loading="lazy">' : "") +
      badgeHtml +
      "</a>" +
      '<div class="find-your-fit__result-body">' +
      '<h3 class="find-your-fit__result-title"><a data-fyf-product-link href="' + esc(productUrl) + '">' + esc(item.title || "Recommended frame") + "</a></h3>" +
      priceHtml +
      colorInsightHtml +
      swatches +
      '<div class="find-your-fit__result-actions">' +
      primaryCtaCompact +
      cartBtn +
      "</div></div></article>"
    );
  }

  function priceInner(price, compareAt) {
    var compare = compareAt && compareAt !== price
      ? '<span class="find-your-fit__compare-price">$' + esc(compareAt) + "</span>"
      : "";
    return '<span class="find-your-fit__current-price">$' + esc(price) + "</span>" + compare;
  }

  /* ── Colour swatches: in-place selection ─────────────────────────────────
     Tapping a swatch updates only its own card, using that colour's own data
     from Shopify's product endpoint. Rules (see PLAN-tyf-swatch-selection.md):
       - exact variant image only; never the product's default photo
       - latest tap wins per card; results replaced/retaken => stale work is
         discarded silently (success AND failure)
       - every field changes in one synchronous step, after the image has loaded
       - USD only (prices are hundredths); anything else keeps plain links */

  var SWATCH_TIMEOUT_MS = 8000;

  function SwatchError(reason) {
    this.reason = reason;
  }

  function bumpResultsGeneration(section) {
    section._fyfGen = (section._fyfGen || 0) + 1;
    section._fyfProducts = {};
  }

  function swatchSelectionSupported(card) {
    if (card.dataset.fyfSelect === "off") return false;
    var cur = window.Shopify && window.Shopify.currency;
    return Boolean(cur && cur.active === "USD");
  }

  function isCurrentSelection(section, card, seq, gen) {
    return seq === card._fyfSeq && gen === (section._fyfGen || 0) && document.contains(card);
  }

  function centsOrNull(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value && value >= 0 ? value : null;
  }

  function formatCents(cents) {
    var rest = cents % 100;
    return Math.floor(cents / 100) + "." + (rest < 10 ? "0" : "") + rest;
  }

  function fixed2(value) {
    var n = Number(value);
    return isFinite(n) ? n.toFixed(2) : "";
  }

  function withWidth(src) {
    return src + (src.indexOf("?") < 0 ? "?" : "&") + "width=900";
  }

  function fetchProductJson(section, handle) {
    var cache = section._fyfProducts || (section._fyfProducts = {});
    if (cache[handle]) return Promise.resolve(cache[handle]);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    var ctl = typeof AbortController === "function" ? new AbortController() : null;
    var timer = null;
    // One deadline for the WHOLE read: headers, body and validation. The race also
    // bounds the wait where AbortController is missing or the body stalls after
    // the headers arrive. The timer is cleared on every settlement.
    var deadline = new Promise(function (resolve, reject) {
      timer = window.setTimeout(function () {
        if (ctl) ctl.abort();
        reject(new SwatchError("timeout"));
      }, SWATCH_TIMEOUT_MS);
    });
    var work = fetch(root + "products/" + encodeURIComponent(handle) + ".js", {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
      signal: ctl ? ctl.signal : undefined,
    })
      .then(function (res) {
        if (!res.ok) throw new SwatchError("http");
        return res.json();
      })
      .then(function (product) {
        if (!product || !Array.isArray(product.variants)) throw new SwatchError("bad-json");
        return product;
      });
    return Promise.race([work, deadline]).then(
      function (product) {
        window.clearTimeout(timer);
        cache[handle] = product;
        return product;
      },
      function (err) {
        window.clearTimeout(timer);
        throw err instanceof SwatchError ? err : new SwatchError("network");
      }
    );
  }

  function preloadImage(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      var timer = window.setTimeout(function () {
        img.onload = img.onerror = null;
        reject(new SwatchError("image"));
      }, SWATCH_TIMEOUT_MS);
      img.onload = function () {
        window.clearTimeout(timer);
        resolve();
      };
      img.onerror = function () {
        window.clearTimeout(timer);
        reject(new SwatchError("image"));
      };
      img.src = src;
    });
  }

  function findVariant(product, id) {
    for (var i = 0; i < product.variants.length; i++) {
      if (String(product.variants[i].id) === String(id)) return product.variants[i];
    }
    return null;
  }

  // The starting price on the card came from the recommend API. Before the first
  // swap, the SALE price of the same variant must match in Shopify's data; if it
  // does not, the two sources use a different price basis and we must not mix
  // them. The compare-at (strike-through) price is deliberately NOT part of this
  // check: the API sends one compare-at value for every market, while Shopify
  // omits it in markets that have none, so requiring a match switched the feature
  // off for those shoppers. After a swap the compare-at shown is Shopify's, i.e.
  // the one for the shopper's own market.
  function initialPriceMatches(card, product) {
    var base = findVariant(product, card.dataset.initialVariant);
    if (!base) return false;
    var price = centsOrNull(base.price);
    if (price === null) return false;
    return formatCents(price) === fixed2(card.dataset.price);
  }

  function loadSwatchVariant(section, card, swatch) {
    return fetchProductJson(section, card.dataset.handle).then(function (product) {
      var variant = findVariant(product, swatch.dataset.variant);
      if (!variant) throw new SwatchError("missing-variant");
      if (variant.available !== true) throw new SwatchError("unavailable");
      var price = centsOrNull(variant.price);
      if (price === null || price <= 0) throw new SwatchError("bad-price");
      var cmp = variant.compare_at_price == null ? null : centsOrNull(variant.compare_at_price);
      if (variant.compare_at_price != null && cmp === null) throw new SwatchError("bad-price");
      var src = variant.featured_image && variant.featured_image.src;
      if (!src) throw new SwatchError("no-image");
      // Read-only: report what the price check found. The caller applies the
      // consequence ("off" flag, "checked" flag) only after its stale-request
      // guard, so an obsolete response can never change the card.
      var needsBasisCheck = !card._fyfPriceChecked;
      if (needsBasisCheck && !initialPriceMatches(card, product)) return { basisMismatch: true };
      var image = withWidth(src);
      return preloadImage(image).then(function () {
        return {
          price: formatCents(price),
          compare: cmp !== null && cmp > price ? formatCents(cmp) : "",
          image: image,
          checkedBasis: needsBasisCheck,
        };
      });
    });
  }

  function setCartDisabled(card, disabled) {
    var btn = card.querySelector("[data-fyf-cart-btn]");
    if (!btn) return;
    btn.disabled = disabled;
    if (disabled) btn.setAttribute("aria-disabled", "true");
    else btn.removeAttribute("aria-disabled");
  }

  function clearSwatchNote(card) {
    var note = card.querySelector("[data-fyf-note]");
    if (note && note.parentNode) note.parentNode.removeChild(note);
  }

  function endSwatchLoading(card) {
    card.removeAttribute("aria-busy");
    card.querySelectorAll("[data-fyf-swatch]").forEach(function (s) {
      s.classList.remove("is-loading");
    });
  }

  function selectSwatch(section, els, swatch, event) {
    var isClick = event.type === "click";
    if (isClick && (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)) return;
    if (!isClick && (event.metaKey || event.ctrlKey || event.altKey)) return;
    var card = swatch.closest("[data-fyf-card]");
    if (!card || !swatchSelectionSupported(card)) return; // plain link behaviour
    event.preventDefault();
    if (swatch.getAttribute("aria-disabled") === "true") return; // unavailable colour stays unselectable
    if (swatch.getAttribute("aria-current") === "true") {
      // Tapping the colour that is already shown while another is still loading
      // is the latest choice: cancel the pending one (its result will be seen
      // as obsolete) and put the card back to its committed purchase state.
      if (card.getAttribute("aria-busy") === "true") {
        card._fyfSeq = (card._fyfSeq || 0) + 1;
        endSwatchLoading(card);
        clearSwatchNote(card);
        setCartDisabled(card, card._fyfCartBase === false);
      }
      return;
    }

    var seq = (card._fyfSeq = (card._fyfSeq || 0) + 1);
    var gen = section._fyfGen || 0;
    var name = (swatch.querySelector(".find-your-fit__swatch-label") || swatch).textContent.trim();

    clearSwatchNote(card);
    card.setAttribute("aria-busy", "true");
    card.querySelectorAll("[data-fyf-swatch]").forEach(function (s) {
      s.classList.toggle("is-loading", s === swatch);
    });
    setCartDisabled(card, true);

    loadSwatchVariant(section, card, swatch).then(
      function (result) {
        // Obsolete work (a newer tap, new results, Retake) exits before touching
        // any state: no button restore, no busy clear, no announcement.
        if (!isCurrentSelection(section, card, seq, gen)) return;
        if (result.basisMismatch) {
          // The sale prices from the two sources disagree: stop selecting in
          // place on this card and do what the swatch always did.
          card.dataset.fyfSelect = "off";
          failSwatchSelection(els, card, swatch, name, new SwatchError("price-basis"));
          return;
        }
        if (result.checkedBasis) card._fyfPriceChecked = true;
        applySwatchSelection(card, swatch, result);
        setStatus(els.status, "Colour: " + name);
      },
      function (err) {
        if (!isCurrentSelection(section, card, seq, gen)) return;
        failSwatchSelection(els, card, swatch, name, err);
      }
    );
  }

  function applySwatchSelection(card, swatch, result) {
    var title = card.dataset.title || "Frame";
    var name = (swatch.querySelector(".find-your-fit__swatch-label") || swatch).textContent.trim();
    var productUrl = swatch.dataset.productUrl;
    var tryOn = swatch.dataset.tryonUrl;

    var img = card.querySelector("[data-fyf-img]");
    if (img) {
      img.src = result.image;
      img.alt = title + ", " + name;
    }
    var price = card.querySelector("[data-fyf-price]");
    if (price) price.innerHTML = priceInner(result.price, result.compare);

    card.querySelectorAll("[data-fyf-cta]").forEach(function (cta) {
      cta.href = tryOn || productUrl;
      cta.textContent = tryOn ? "Try on" : "View product";
    });
    var link = card.querySelector("[data-fyf-link]");
    if (link) {
      link.href = productUrl;
      link.hidden = !tryOn;
    }
    card.querySelectorAll("[data-fyf-product-link]").forEach(function (a) {
      a.href = productUrl;
    });
    var cartId = card.querySelector("[data-fyf-cart-id]");
    if (cartId) cartId.value = swatch.dataset.variant;

    card.querySelectorAll("[data-fyf-swatch]").forEach(function (s) {
      var on = s === swatch;
      s.classList.toggle("is-selected", on);
      if (on) s.setAttribute("aria-current", "true");
      else s.removeAttribute("aria-current");
    });

    card._fyfCartBase = true;
    setCartDisabled(card, false);
    endSwatchLoading(card);
  }

  function failSwatchSelection(els, card, swatch, name, err) {
    endSwatchLoading(card);
    // Back to the committed selection's purchase state, never to "enabled" by default.
    setCartDisabled(card, card._fyfCartBase === false);
    var reason = err && err.reason;
    if (reason === "price-basis") {
      // The two price sources disagree: do what the swatch always did.
      window.location.assign(swatch.href);
      return;
    }
    if (reason === "unavailable") {
      swatch.setAttribute("aria-disabled", "true");
      swatch.classList.add("is-disabled");
      setStatus(els.status, name + " is unavailable.");
      return;
    }
    setStatus(els.status, "Couldn't load " + name + ". You can view it on its product page.");
    var note = document.createElement("p");
    note.className = "find-your-fit__swatch-note";
    note.setAttribute("data-fyf-note", "");
    note.appendChild(document.createTextNode("Couldn't load " + name + ". "));
    var a = document.createElement("a");
    a.href = swatch.href;
    a.textContent = "View it on its product page";
    note.appendChild(a);
    var row = card.querySelector(".find-your-fit__swatches");
    if (row && row.parentNode) row.parentNode.insertBefore(note, row.nextSibling);
  }

  function colorNameToHex(name) {
    if (!name) return "";
    var n = name.toLowerCase().replace(/[^a-z]/g, "");
    var map = {
      black: "#1a1a2e", blue: "#4a6fa5", brown: "#8b6f47", gold: "#c5a55a",
      green: "#5a7a5a", grey: "#8c8c8c", gray: "#8c8c8c", red: "#b54545",
      pink: "#d4829c", purple: "#7a5a8a", tortoiseshell: "#8b6914",
      tortoise: "#8b6914", silver: "#b0b0b0", white: "#f5f5f5",
      clear: "#e8e8e8", translucent: "#d0d0d0", orange: "#cc7a3a",
      yellow: "#c5a832", navy: "#2c3e6b", wine: "#722f37", rose: "#c97f7f",
      cream: "#f0e6d3", amber: "#c98a2e", teal: "#4a8a8a",
      patternblue: "#5a7aaa", patternbrown: "#9a7a52", translucentgreen: "#7aaa7a",
      translucentgrey: "#aaaaaa",
    };
    return map[n] || "";
  }

  function showErrorCard(els, title, copy, mode, browseUrl) {
    var actions = mode === "browse"
      ? '<a class="find-your-fit__button find-your-fit__button--primary" href="' + esc(browseUrl) + '">Browse all frames</a>'
      : '<button class="find-your-fit__button find-your-fit__button--primary" type="button" data-action="open-manual">Open manual quiz</button><button class="find-your-fit__button find-your-fit__button--secondary" type="button" data-action="retake">Retake photo</button>';

    els.results.innerHTML =
      '<div class="find-your-fit__empty">' +
      '<h2 class="find-your-fit__title">' + esc(title) + "</h2>" +
      '<p class="find-your-fit__text">' + esc(copy) + "</p>" +
      '<div class="find-your-fit__summary-links">' + actions + "</div></div>";
  }

  function hydrateFromQuery(section, state, els, params) {
    var shape = params.get("fs");
    var size = params.get("sz");
    var gender = params.get("g");
    var style = params.get("sv");
    var use = params.get("pu");

    if (shape && SHAPE_LABELS[shape]) state.faceShape = shape;
    if (size) state.faceSize = normalizeFaceSize(size);
    if (gender) state.gender = gender;
    if (style) state.styleVibe = style;
    if (use) state.primaryUse = use;

    syncSelections(section, state, els);
    if (shape && size && gender && style && use) {
      state.flow = "manual";
      fetchResults(section, state, els);
    }
  }

  /* One-directional: dropdown -> pills. The pills are decorative and are not
     clickable; there is deliberately no reverse binding.
     `data-size` holds CANONICAL values, so compare against `state.faceSize` —
     never against the select's raw value, which is legacy (small/large). */
  function syncSizePills(els, state) {
    if (!els.sizeVisual) return;
    els.sizeVisual.querySelectorAll("[data-size]").forEach(function (pill) {
      pill.classList.toggle("is-active", pill.dataset.size === state.faceSize);
    });
  }

  /* "Retake quiz" reset. Previously this cleared the captured photo and the
     last response and nothing else, so every answer survived invisibly — a
     returning user could see "Medium" on screen while the engine still held
     "narrow" from ten minutes earlier.
     Three surfaces have to agree or the bug comes back in a new shape:
     STATE, DOM, and the URL. Consent is deliberately preserved. */
  function resetQuiz(section, state, els) {
    // Camera lifecycle via the shared helper, so this cannot drift from it.
    // Preserves `state.detectionInstance` — the loaded model is expensive and
    // there is no reason to rebuild it.
    bumpResultsGeneration(section);
    stopCamera(state, els.video);
    clearCaptured(state);

    // STATE — answers back to their initial values.
    state.faceShape = "oval";
    state.faceSize = "medium";
    state.sizeKnown = "no";
    state.frameSizeMm = "";
    state.colorPreference = "none";
    state.gender = "women";
    state.styleVibe = "classic";
    state.primaryUse = "everyday";
    state.latestResponse = null;
    state.flow = "camera";

    // DOM — re-render every control from state, clear rendered output.
    syncSelections(section, state, els);
    if (els.results) els.results.innerHTML = "";
    if (els.fileName) els.fileName.textContent = "";
    // Without this, re-selecting the SAME photo fires no `change` event,
    // because the input's value never changed. The upload silently does
    // nothing and the shopper gets no feedback at all.
    if (els.fileInput) els.fileInput.value = "";
    updateManualMessage(els, "");
    setStatus(els.status, "");

    // URL — strip ONLY our share params. `hydrateFromQuery` auto-submits when
    // all five are present, so leaving them means a refresh silently re-runs
    // the answers the shopper just cleared. Everything else (utm_*, etc.) is
    // not ours to remove.
    try {
      var url = new URL(window.location.href);
      ["fs", "sz", "g", "sv", "pu"].forEach(function (key) {
        url.searchParams.delete(key);
      });
      window.history.replaceState({}, "", url.toString());
    } catch (err) {
      /* history unavailable — the state and DOM resets above still stand */
    }
  }

  function syncSelections(section, state, els) {
    updateSelectionByValue(section.querySelector('[data-role="gender-options"]'), state.gender);
    updateSelectionByValue(section.querySelector('[data-role="style-options"]'), state.styleVibe);
    updateSelectionByValue(section.querySelector('[data-role="use-options"]'), state.primaryUse);
    updateSelectionByShape(section.querySelector('[data-role="shape-grid"]'), state.faceShape);
    if (section.querySelector('[data-role="face-size"]')) {
      section.querySelector('[data-role="face-size"]').value = legacyFaceSizeValue(state.faceSize);
    }
    // Controls the previous version never re-rendered, so they kept showing
    // stale selections after a rehydrate or a retake.
    if (els) {
      updateSelectionByValue(els.sizeKnownGroup, state.sizeKnown);
      if (els.sizeKnownGroup) els.sizeKnownGroup.dataset.value = state.sizeKnown;
      updateSelectionByValue(els.colorGroup, state.colorPreference);
      if (els.sizeMm) els.sizeMm.value = state.frameSizeMm;
      syncSizePills(els, state);
      toggleSizeFields(els, state);
    }
  }

  async function shareResults(state, els) {
    var url = new URL(window.location.href);
    var latest = state.latestResponse && state.latestResponse.data;
    var sharedShape = latest && latest.fitProfile && latest.fitProfile.shape && latest.fitProfile.shape.primary
      ? latest.fitProfile.shape.primary
      : state.faceShape;
    var sharedSize = latest && latest.fitProfile && latest.fitProfile.fitCategory
      ? latest.fitProfile.fitCategory
      : state.faceSize;

    url.searchParams.set("fs", sharedShape);
    url.searchParams.set("sz", sharedSize);
    url.searchParams.set("g", state.gender);
    url.searchParams.set("sv", state.styleVibe);
    url.searchParams.set("pu", state.primaryUse);

    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(url.toString());
      showToast(els, "Share link copied to clipboard");
    }
  }

  function bindOptionGroup(container, onChange) {
    if (!container) return;
    container.addEventListener("click", function (event) {
      var button = event.target.closest("[data-value]");
      if (!button) return;
      selectButtonGroup(container.querySelectorAll("[data-value]"), button);
      onChange(button.dataset.value || "", button, container);
    });
  }

  function selectButtonGroup(buttons, activeButton) {
    buttons.forEach(function (button) {
      button.classList.toggle("is-selected", button === activeButton);
    });
  }

  function updateSelectionByValue(container, value) {
    if (!container) return;
    var target = container.querySelector('[data-value="' + value + '"]');
    if (target) selectButtonGroup(container.querySelectorAll("[data-value]"), target);
  }

  function updateSelectionByShape(container, value) {
    if (!container) return;
    var target = container.querySelector('[data-shape="' + value + '"]');
    if (target) selectButtonGroup(container.querySelectorAll("[data-shape]"), target);
  }

  function toggleSizeFields(els, state) {
    if (els.sizeVisual) els.sizeVisual.hidden = state.sizeKnown === "yes";
    if (els.sizeMmField) els.sizeMmField.hidden = state.sizeKnown !== "yes";
  }

  function showStep(section, step) {
    // Read BEFORE the panels toggle: the control the shopper just used is about
    // to be hidden, and focus would otherwise fall to <body>. Only act when
    // focus was already inside the section, so a share link that jumps straight
    // to results on page load does not steal focus.
    var hadFocus = section.contains(document.activeElement);
    if (step !== "results") bumpResultsGeneration(section);
    section.querySelectorAll("[data-step]").forEach(function (panel) {
      panel.classList.toggle("is-active", panel.dataset.step === step);
    });
    updateProgress(section, step);
    if (hadFocus) focusStep(section, step);
  }

  function focusStep(section, step) {
    var panel = section.querySelector('[data-step="' + step + '"]');
    var target = step === "intro"
      ? section.querySelector("h1")
      : panel && (
          // Results: the fit summary comes BEFORE its Share/Retake/Browse
          // controls and the product cards. The first `.find-your-fit__title`
          // there is the top product's heading, which would skip all of that.
          panel.querySelector(".find-your-fit__summary") ||
          panel.querySelector(".find-your-fit__title") ||
          panel
        );
    if (!target) return;
    if (!target.hasAttribute("tabindex")) target.setAttribute("tabindex", "-1");
    target.focus();
  }

  function updateProgress(section, step) {
    var current = STEP_PROGRESS[step] || 1;
    section.querySelectorAll("[data-progress]").forEach(function (dot) {
      var num = parseInt(dot.dataset.progress, 10);
      dot.classList.toggle("is-complete", num < current);
      dot.classList.toggle("is-current", num === current);
    });
  }

  function setStatus(node, text) {
    if (node) node.textContent = text || "";
  }

  function setCameraMessage(els, text, subText) {
    if (els.cameraStatus) els.cameraStatus.textContent = text || "";
    if (els.cameraHint) els.cameraHint.textContent = subText || "";
  }

  function updateManualMessage(els, text) {
    if (!els.manualMessage) return;
    els.manualMessage.hidden = !text;
    els.manualMessage.textContent = text || "";
  }

  function showToast(els, message) {
    if (!els.toast) return;
    els.toast.textContent = message || "Link copied";
    els.toast.classList.add("is-visible");
    window.setTimeout(function () {
      els.toast.classList.remove("is-visible");
    }, 2800);
  }

  function getStoredConsent() {
    try {
      return window.localStorage.getItem(CONSENT_KEY) === "true";
    } catch (err) {
      return false;
    }
  }

  function storeConsent() {
    try {
      window.localStorage.setItem(CONSENT_KEY, "true");
    } catch (err) {}
  }

  function flashCapture(els) {
    if (!els.cameraShell) return;
    els.cameraShell.classList.add("is-flashing");
    window.setTimeout(function () {
      els.cameraShell.classList.remove("is-flashing");
    }, 450);
  }

  function revealManualCapture(els) {
    if (els.manualCapture) els.manualCapture.hidden = false;
  }

  function hideManualCapture(els) {
    if (els.manualCapture) els.manualCapture.hidden = true;
  }

  /* Two rapid file selections can finish out of order. Without a generation
     guard the OLDER resize wins the race and overwrites the newer choice, then
     advances the flow with the wrong photo. */
  var fileSelectionSeq = 0;

  async function setCapturedFile(state, file, els) {
    var mySelection = ++fileSelectionSeq;
    /* Previously the chosen file was uploaded at its original size. */
    var resized = await resizeUploadedFile(file);
    /* A newer selection started while this one was resizing: abandon quietly.
       Returning false also stops the caller advancing the flow. */
    if (mySelection !== fileSelectionSeq) return false;
    if (!resized.ok) {
      clearCaptured(state);
      /* Stop the camera FIRST. Its detection loop rewrites the camera message
         every frame, so a rejection set while it runs is overwritten before the
         shopper can read it - measured 2026-08-24, the message never appeared on
         screen at all. Stopping the loop is what makes the failure visible. */
      stopCamera(state, els.video);
      revealManualCapture(els);
      setCameraMessage(els, "We couldn't use that photo.", resizeFailureCopy(resized.reason));
      setStatus(els.status, "Photo not accepted.");
      return false;
    }
    clearCaptured(state);
    state.capturedBlob = resized.blob;
    state.capturedPreviewUrl = URL.createObjectURL(resized.blob);
    if (els.fileName) els.fileName.textContent = file.name;
    hideManualCapture(els);
    return true;
  }

  function clearCaptured(state) {
    if (state.capturedPreviewUrl) URL.revokeObjectURL(state.capturedPreviewUrl);
    state.capturedPreviewUrl = "";
    state.capturedBlob = null;
  }

  function buildVariantUrl(handle, variantId, includeVto) {
    if (!handle) return "#";
    var numericId = extractVariantId(variantId);
    var url = "/products/" + handle;
    var params = [];
    if (numericId) params.push("variant=" + encodeURIComponent(numericId));
    if (includeVto) params.push("vto=1");
    return params.length ? url + "?" + params.join("&") : url;
  }

  function extractVariantId(variantId) {
    if (!variantId) return "";
    var value = String(variantId);
    return value.indexOf("gid://") === 0 ? value.substring(value.lastIndexOf("/") + 1) : value;
  }

  function numberOr(value, fallback) {
    return typeof value === "number" && isFinite(value) ? value : fallback;
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function capitalize(value) {
    var text = String(value || "");
    return text ? text.charAt(0).toUpperCase() + text.slice(1) : "";
  }

  function normalizeFaceSize(value) {
    if (value === "small") return "narrow";
    if (value === "large") return "wide";
    return value || "medium";
  }

  function legacyFaceSizeValue(value) {
    if (value === "narrow") return "small";
    if (value === "wide") return "large";
    return value || "medium";
  }

  function esc(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }
})();
